import React from "react";
import { connect } from "react-redux";
import { Form } from "semantic-ui-react";
import { t } from "../../../constant/translations";

const ChargeModelSelectComponent = (props) => {
  let opts = [];
  if (props.charges) {
    const optSet = new Set();
    props.charges.forEach((charge) => {
      charge.details.forEach((dt) => {
        optSet.add(dt.model);
      });
    });
    opts = Array.from(optSet).map((opt) => {
      return { text: opt, value: opt };
    });
    opts.unshift({ text: t("charge.no_matter"), value: null });
  }

  return (
    <Form.Select
      options={opts}
      value={props.value || ""}
      onChange={props.onChange}
    />
  );
};

function mapStateToProps(state) {
  return {
    charges: state.charge.entities,
  };
}

export const ChargeModelSelect = connect(mapStateToProps)(
  ChargeModelSelectComponent
);
